export default function msgInfo(message,summary) {
    this.$toast.add({
        severity: "info",
        summary: summary = summary ? summary : 'Informativo',
        detail: message,
        life: 10000,
    });
}